module.exports = __webpack_public_path__ + "static/media/circle-clock.5aebc921.svg";